// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-7863b50a] {\n  max-width: 200px;\n  margin: 10px auto 20px;\n}\nimg.lyris-logo[data-v-7863b50a] {\n  max-width: 80px;\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
